import { Outlet, createFileRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/payroll-engine/_layout')({
  component: Layout
});

/** payroll-engine 全体のラッパー: LABOR_PLUS_MOCK gate + bare Outlet。
 *  list ページが製品ヘッダ (タブ付き) を必要とする場合は、各 list ルートで
 *  `PayrollEngineListLayout` を opt-in に巻く (Option C)。
 *  detail ページは何も巻かず、独自に EngineDetailHeader を表示する。 */
function Layout() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.payrollEngine'
  });
  useDocumentTitle(t('pageTitle'));
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }
  return <div className="flex flex-col">
      <Outlet />
    </div>;
}